// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isWednesday as fn } from "../isWednesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isWednesdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isWednesdayWithOptions;
